import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import authRoutes from './modules/auth'
import adminRoutes from './modules/admin'
import student from './modules/student'
import courseStudyRoutes from './modules/courseStudy'

import studentPortrait from './modules/studentPortrait'
// 页面路由
const routes: RouteRecordRaw[] = [
  //主页路由
  {
    path: '/',
    redirect: '/home',
    meta: {
      title: '湖北中医药大学同等学力申硕首页｜同等学力申请硕士学位招生简章',
    },
  },
  // 认证相关路由
  ...authRoutes,
  // 管理后台路由
  adminRoutes,
  studentPortrait,
  ...student,
  courseStudyRoutes,
  // 微应用页面
  {
    path: "/micro-app/:appName/:page*",
    name: "MicroApp",
    component: () => import("@/views/MicroAppContainer.vue"),
    meta: {
      title: "子应用",
      scrollControl: false, // 添加自定义元信息
    },
  },
  // 404页面
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
    meta: {
      title: "404",
    },
  },
  {
    path: "/enrollIntro",
    name: "enrollIntro",
    component: () => import("@/views/enrollIntro.vue"),
    meta: {
      title: "招生简章",
    },
  },
  {
    path: "/cqsfEnrollIntro",
    name: "cqsfEnrollIntro",
    component: () => import("@/views/cqsfEnrollIntro/index.vue"),
    meta: {
      title: "湖北中医药大学招生简章",
    },
  },
  {
    path: "/getDegreeProcess",
    name: "getDegreeProcess",
    component: () => import("@/views/getDegreeProcess.vue"),
    meta: {
      title: "同等学力申请法学硕士学位证全流程",
    },
  },
  {
    path: "/welcomeNewStudent",
    name: "welcomeNewStudent",
    component: () => import("@/views/welcomeNewStudent.vue"),
    meta: {
      title: "欢迎2025级新生",
    },
  },
  {
    path: "/applyMasterStudy",
    name: "applyMasterStudy",
    component: () => import("@/views/applyMasterStudy.vue"),
    meta: {
      title: "法学申硕学习方式",
    },
  },
  {
    path: "/payment",
    name: "Payment",
    component: () => import("@/views/Payment.vue"),
    meta: {
      title: "在线缴费",
    },
  },
  {
    path: "/paymentOrders",
    name: "PaymentOrders",
    component: () => import("@/views/PaymentOrders.vue"),
    meta: {
      title: "缴费订单",
    },
  },
  {
    path: "/paymentPage",
    name: "PaymentPage",
    component: () => import("@/views/PaymentPage.vue"),
    meta: {
      title: "学费缴纳",
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || "/"),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   // 不再使用savedPosition，确保始终滚动到顶部
  //   // if (savedPosition) {
  //   //   return savedPosition
  //   // }
    
  //   // 处理锚点
  //   if (to.hash) {
  //     return {
  //       el: to.hash,
  //       behavior: 'smooth',
  //       // 根据导航栏高度调整偏移量
  //       top: document.querySelector('.header')?.clientHeight || 64 
  //     }
  //   }
    
  //   // 默认滚动到顶部
  //   return { top: 0, behavior: 'auto' }
  // }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  // document.title = `${to.meta.title || '易甄学研修平台'} - 易甄学研修平台`
  
  // 对于 QueryResult 页面，不设置固定标题，让组件自己控制
  if (to.path !== '/QueryResult') {
    document.title = `${to.meta.title || ''}`
  }
  
  next()
})

export default router 
